import { CartItemJH, CartRawItem } from 'src/features/analytics/utils/eventTypes';

export const determineCustomisedItems = (items: CartItemJH[], rawItems?: CartRawItem[]) => {
    const getBuyPrice = (item: CartItemJH) => {
        return rawItems?.find((rawItem) => rawItem.id === item.id)?.product?.buy_price;
    };

    return items.map((item) => {
        if (item.__typename === 'ConfigurableCartItem' || item.__typename === 'BundleCartItem') {
            const customisation = items.find((customisationItem) => customisationItem.product.name.includes(item.id));

            if (customisation) {
                return { ...item, customised: true, buyPrice: getBuyPrice(item) };
            }

            return { ...item, customised: false, buyPrice: getBuyPrice(item) };
        }

        return { ...item, buyPrice: getBuyPrice(item) };
    });
};
